import React from 'react';

import { Route } from '@react-router';
import { ClarityService } from '../microsoftClarity';

/**
 * Conditionally include external service scripts based on route
 */
export const RouteBasedServices = () => {
  return (
    <>
      {/* Admin registry + shop (admin + public) + admin planning (room blocks + instant room blocks) + hotel PDPs + travel checkout/reservations */}
      <Route
        path={[
          '/:eventHandle/edit/registry',
          '/:eventHandle/edit/accommodations',
          '/shop',
          '/:eventHandle/edit/planning',
          '/createwedding',
          '/createbabyregistry',
          '/:eventHandle/travel',
          '/:eventHandle/accommodations/:accommodationId',
          '/stays/:stayId',
          '/travel/checkout',
          '/travel/car/checkout',
          '/travel/car/reservations',
          '/travel/reservations',
        ]}
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
      {/* exact to avoid prefix-matching hotel PDP (/:eventHandle/accommodations/:accommodationId) */}
      <Route
        exact
        path="/:eventHandle/accommodations"
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
    </>
  );
};
